import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import api from "./api";

const AuthCtx = createContext(null);

// httpOnly cookie session: we never touch the token in JS. We only track the
// user identity returned by the server (via /auth/me and /auth/login).

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser({ email: r.data.email, role: r.data.role, name: r.data.name });
    return r.data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    setUser(null);
  };

  const value = useMemo(() => ({ user, ready, login, logout }), [user, ready]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
